import React from "react"
import { EmissoesParaMeuCNPJContextProvider } from "./context/EmissoesParaMeuCNPJContextProvider"
import { EmissoesParaMeuCNPJ } from "./EmissoesParaMeuCNPJ"

export function Index() {
    return (
        <EmissoesParaMeuCNPJContextProvider>
            <EmissoesParaMeuCNPJ />
        </EmissoesParaMeuCNPJContextProvider>
    )
}
